import { render, staticRenderFns } from "./manage-extended-preference-modal.vue?vue&type=template&id=2f0966b6"
import script from "./manage-extended-preference-modal.vue?vue&type=script&lang=js"
export * from "./manage-extended-preference-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports